// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--oupeT","title":"_7a3fb80146--title--AQkyG","content":"_7a3fb80146--content--TcMHR"};